// compares flat objects with same keys. new keys are ignored.
export const flatObjectDiffChecker = (
  base: Record<string, any>,
  objectTobeCompared: Record<string, any>,
) => {
  return Object.keys(base).reduce((diff, key) => {
    if (objectTobeCompared[key] && objectTobeCompared[key] !== base[key]) {
      return {
        ...diff,
        [key]: objectTobeCompared[key],
      };
    }

    return diff;
  }, {});
};
